// extracted by mini-css-extract-plugin
module.exports = {"main-content":"WishList_main-content__3d0yQ","msg":"WishList_msg__10wwP","prod-listing":"WishList_prod-listing__1dBlG"};